@switch (context ? context.type : '') {
    @default {
        <fui-edit-text-input
            [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
            [readonly]="!modifiable"
            [label]="label" [labelI18NParams]="labelI18NParams"
            (focussed$)="onFocussed($event)" [notation]="notation"
            [placeholder]="placeholder"></fui-edit-text-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-text-input
            [disabled]="disabled" #input [(ngModel)]="value"
            [readonly]="!modifiable"
            [label]="label" [labelI18NParams]="labelI18NParams" [placeholder]="placeholder"
            (focussed$)="onFocussed($event)"></fui-filter-text-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-text-input
            [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
            [readonly]="!modifiable"
            (focussed$)="onFocussed($event)" [notation]="notation"
            [placeholder]="placeholder"></fui-inline-text-input>
    }
    @case (contextType.PILL) {
        <fui-text-pill
            [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
            [readonly]="!modifiable"
            [label]="label" [labelI18NParams]="labelI18NParams"
            (focussed$)="onFocussed($event)"
            [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"></fui-text-pill>
    }
}
